package com.mshopsas.enterprise.aiw.scan.network.response

import kotlinx.serialization.Serializable

@Serializable
data class BasketStatusResponse(
    val result: String?,
    val auditCode: String?
)
